/**
 * Customer accounts are only supported in (currently) USD currency.
 */

export const UnsupportedCurrency = ({ currency }) => {
  const title = currency
    ? 'We\'re sorry, your Rackspace account is billed in an unsupported currency'
    : 'We\'re sorry, we were unable to verify the billing currency of your Rackspace account';

  const reason = currency ? (
    <p>
      Since your account is billed in
      {' '}
      {currency}
      , a new Rackspace account must be created.
      To complete this action, please visit &nbsp;
      <a href="https://cart.rackspace.com/gcp">https://cart.rackspace.com/gcp</a>
      &nbsp; and follow the on-screen instructions to create a new account.
      If needed, your Rackspace Account Manager or Sales Representative can assist you
      in this action.
    </p>
  ) : (
    <p>
      However, we were unable to verify the billing currency of your Rackspace account.
      If you need further assistance at this time, please contact your Support team.
    </p>
  );

  return (
    <div>
      <h3>{title}</h3>
      <div>
        <p>
          Rackspace Managed Services for GCP requires that your Rackspace
          account be billed in USD/AUD/CAD dollars, EUR euros, GBP pounds, SAR riyals or MXN pesos.
        </p>
        {reason}
      </div>
    </div>
  );
};
